import { ReceivingCreateRequestController } from './createRequest.controller';
import template from './createRequest.html';

export const receivingCreateRequestComponent = {
  name: 'receivingCreateRequestComponent',
  restrict: 'E',
  template,
  controller: ReceivingCreateRequestController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
